import React from "react";
import { getCurrencyLabel } from "../../store/utils";
import { i18n } from "@euroland/libs";
import useCurrencyName from "../../hooks/useCurrencyName";
import { formatNumberByInstrument } from "../../utils/format-number";

const VictorShowSingleItem = ({ historicalShareList = {} }) => {
  const getCurrencyNameByCode = useCurrencyName()
  const instrumentId = historicalShareList.instrumentId;
  return (
  <div className="history-single-item" tabIndex={0} role='article'>
      <div className="history-single-item__header">
        <label>{i18n.translate("lastTradingPlace")}</label>
        <p aria-label={historicalShareList.close + ' ' + getCurrencyNameByCode(historicalShareList.currency)} role="note">
          {" "}
          {formatNumberByInstrument(historicalShareList.close, instrumentId)} ({getCurrencyLabel(historicalShareList.currency) || "N/A"})
        </p>
      </div>
      <div className="history-single-item__info">
        <div className="history-single-item__info--item history-single-item__info--open">
          <label>{i18n.translate("open")}</label>
          <p >{formatNumberByInstrument(historicalShareList.open, instrumentId)}</p>
        </div>
        <div className="history-single-item__info--item history-single-item__info--hight">
          <label>{i18n.translate("high")}</label>
          <p >{formatNumberByInstrument(historicalShareList.high, instrumentId)}</p>
        </div>
        <div className="history-single-item__info--item history-single-item__info--low">
          <label>{i18n.translate("low")}</label>
          <p >{formatNumberByInstrument(historicalShareList.low, instrumentId)}</p>
        </div>
        <div className="history-single-item__info--item history-single-item__info--volume">
          <label>{i18n.translate("volume")}</label>
          <p>{formatNumberByInstrument(historicalShareList.volume, instrumentId, {decimalDigits: 0})}</p>
        </div>
      </div>
    </div>
  );
};

export default VictorShowSingleItem;
